import styled from "styled-components";

const Text = styled.span`
color: ${props => props.colour ?? props.theme.tl};
font-size: ${props => props.size ?? '14px'};
font-weight: ${props => props.bold ? 'bold' : 'initial'};
line-height: ${props => props.height ?? '30px'};
`;

export default Text;